import React from 'react';
import { Button } from '@/components/ui';
import type { UserProfileDetail } from '../types/userDetail.types';
import { SideItem } from './WorkStatusCard';

export function AccountInfoCard({ user }: { user: UserProfileDetail }) {
 return (
 <div className="bg-white rounded-md p-6 border border-slate-100">
 <h3 className="sm:text-sm text-xs text-slate-800 mb-6">Thông tin tài khoản</h3>

 <div className="space-y-4 mb-6">
 <SideItem label="Email đăng nhập" value={user.account_email} isMasked />
 <SideItem label="Tài khoản" value={user.username} />
 <div className="flex items-center justify-between gap-4">
 <span className="sm:text-sm text-xs text-slate-400 whitespace-nowrap">Vai trò hệ thống</span>
 <span className="px-2 py-0.5 rounded-md bg-emerald-50 text-emerald-600 sm:text-sm text-xs tracking-wider border border-emerald-100">
 {user.role_name}
 </span>
 </div>
 <div className="flex items-center justify-between gap-4">
 <span className="sm:text-sm text-xs text-slate-400 whitespace-nowrap">Trạng thái tài khoản</span>
 <span className="px-2 py-0.5 rounded-md bg-emerald-50 text-emerald-600 sm:text-sm text-xs tracking-wider border border-emerald-100">
 {user.account_status}
 </span>
 </div>
 </div>

 <Button variant="outline" className="w-full h-10 rounded-md sm:text-sm text-xs border-slate-100 text-slate-600 hover:bg-slate-50 transition-all">
 Quản lý tài khoản
 </Button>
 </div>
 );
}
